export const ROLL_ANIMATION_WORDS = [
  'homepage.header.roll.doctor',
  'homepage.header.roll.hospital',
  'homepage.header.roll.surgeon',
  'homepage.header.roll.dentist',
  'homepage.header.roll.cardiologist',
  'homepage.header.roll.dermatologist',
  'homepage.header.roll.paediatrician',
  'homepage.header.roll.urologist',
  'homepage.header.roll.obstetrician',
  'homepage.header.roll.physiotherapist',
  'homepage.header.roll.clinic',
  'homepage.header.roll.care',
  'homepage.header.roll.pharmacy'
]

export const ROLL_ANIMATION_WORDS_DE = [
  'homepage.header.roll.doctor',
  'homepage.header.roll.hospital',
  'homepage.header.roll.surgeon',
  'homepage.header.roll.dentist',
  'homepage.header.roll.cardiologist',
  'homepage.header.roll.dermatologist',
  'homepage.header.roll.paediatrician',
  'homepage.header.roll.orthopaedic',
  'homepage.header.roll.urologist',
  'homepage.header.roll.obstetrician',
  'homepage.header.roll.clinic',
  'homepage.header.roll.care',
  'homepage.header.roll.pharmacy'
]
